module.exports = "/_next/static/images/incorporate-generator-web-page-488e4da4922a5e99e5f9003641fdb5d4.png";